import React from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";
import ProfileEditImage from "./ProfileEditImage";
import { Feather } from "@react-native-vector-icons/feather";
import Button from "components/Partials/Buttons";
import smile from "components/assets/grey_smile.png";

const formatPhoneInput = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const ProfileEditForm = ({form, errors = {}, onChange, onCancel, onSubmit, onImageChange, theme, loading, profile, imageUrl}) => {
  const rowStyle = { marginBottom: 16 };
    const getInputStyle = (fieldName) => [
    styles.input,
    errors[fieldName] ? styles.inputError : null,
  ];
  const resolvedImageUrl = imageUrl || smile;

  // Assemble the payload for saving
  const handleEditSave = () => {
    const payload = {
      //client_id: profile.client_id,       // always include for update
      client_id: form.client_id,
      first_name: form.first_name,
      last_name: form.last_name,
      email_1: form.email_1,
      phone_1: form.phone_1,
      // add image id if needed!
      profile_image_id: profile.profile_image_id
    };
    onSubmit(payload);
  };

  return (

    <View style={{ position: "relative" }}>
      <Feather
        name="x"
        size={24}
        color={theme.colors.mode.textColor}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 10,
          padding: 4,
          cursor: "pointer",
        }}
        onPress={onCancel}
        accessibilityLabel="Close edit form"
        accessibilityRole="button"
      />
      <View style={{ flexDirection: "row", alignItems: "flex-start", marginBottom: 20, paddingRight: 28, width: "100%", }}>
        <ProfileEditImage
          imageUrl={resolvedImageUrl}
          editable
          onImageChange={onImageChange}
          size={72}
        />
        <Text style={{ ...theme.pageTitleText, fontWeight: "bold", fontSize: 22, marginLeft: 20, marginTop: 4, flex: 1, }}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          Edit Profile
        </Text>
      </View>
      <View style={rowStyle}>
        <Text style={{ fontWeight: "bold", marginBottom: 5 }}>First Name</Text>
        <TextInput
          style={getInputStyle("first_name")}
          value={form.first_name}
          onChangeText={(val) => onChange("first_name", val)}
          placeholder="First Name"
        />
        {!!errors.first_name && (
          <Text style={styles.errorText}>{errors.first_name}</Text>
        )}
      </View>
      <View style={rowStyle}>
        <Text style={{ fontWeight: "bold", marginBottom: 5 }}>Last Name</Text>
        <TextInput
          style={getInputStyle("last_name")}
          value={form.last_name}
          onChangeText={(val) => onChange("last_name", val)}
          placeholder="Last Name"
        />
        {!!errors.last_name && (
          <Text style={styles.errorText}>{errors.last_name}</Text>
        )}
      </View>
      <View style={rowStyle}>
        <Text style={{ fontWeight: "bold", marginBottom: 5 }}>Email</Text>
        <TextInput
          style={getInputStyle("email_1")}
          value={form.email_1}
          onChangeText={(val) => onChange("email_1", val)}
          placeholder="Email"
          keyboardType="email-address"
        />
        {!!errors.email_1 && (
          <Text style={styles.errorText}>{errors.email_1}</Text>
        )}
      </View>
      <View style={rowStyle}>
        <Text style={{ fontWeight: "bold", marginBottom: 5 }}>Phone</Text>
        <TextInput
          style={getInputStyle("phone_1")}
          value={formatPhoneInput(form.phone_1)}
          onChangeText={(val) =>
            onChange("phone_1", String(val || "").replace(/\D/g, "").slice(0, 10))
          }
          placeholder="Phone Number"
          keyboardType="phone-pad"
          maxLength={14}
        />
        {!!errors.phone_1 && (
          <Text style={styles.errorText}>{errors.phone_1}</Text>
        )}
      </View>
      <View style={{ flexDirection: "row", gap: 16, marginTop: 20 }}>
        <Button
          text="Cancel"
          type="secondary"
          style={{
            flex: 1,
            borderWidth: 1,
            marginRight: 10,
            backgroundColor: "#fff",
            borderColor: "#2a7a34",
          }}
          onPress={onCancel}
        />
        <Button
          text="Update Profile"
          type="primary"
          style={{
            flex: 2,
            backgroundColor: "#2a7a34",
          }}
          onPress={handleEditSave}
          disabled={loading}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  input: {
    borderWidth: 1,
    borderRadius: 5,
    borderColor: "#bbb",
    padding: 8,
    backgroundColor: "#fff",
  },
  inputError: {
    borderColor: "#d93025",
    borderWidth: 1.5,
  },
  errorText: {
    color: "#d93025",
    fontSize: 12,
    marginTop: 4,
  },
});

export default ProfileEditForm;